import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ClienteService {
  header = new HttpHeaders({
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
  });
  authBasic = 'Basic c2VydmljZXM6MC49ajNEMnNzMS53Mjkt';
  pais = environment.PAIS;
  constructor(private httpClient: HttpClient) {}


  guardaAuditoria(params: any = '') {
    return this.httpClient.post(`${environment.urlCliente}/guardaAuditoria`, params);
  }
}

